import { deleteSensorGroup } from '@Actions/sensorGroup.action';
import {
	Button,
	StylovyzeComposableDialog,
	useToggle,
} from '@innovyze/stylovyze';
import { Checkbox, FormControl } from '@mui/material';
import { useGlobalization } from '@Translations/useGlobalization';
import { SensorGroupFormValues } from '@Types/sensorGroup.types';
import { FormikProps } from 'formik';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

interface Props {
	onCancel: () => void;
	open: boolean;
	formRef: React.MutableRefObject<
		FormikProps<SensorGroupFormValues> | undefined
	>;
}

export default function DeleteSensorGroupModal({
	open,
	onCancel,
	formRef,
}: Props) {
	const { t } = useGlobalization();
	const [checked, toggleChecked, setChecked] = useToggle(false);
	const { sensorGroupId } = useParams<{ sensorGroupId: string }>();
	const dispatch = useDispatch();
	const wrappedOnCancel = () => {
		onCancel();
		setChecked(false);
	};
	return (
		<StylovyzeComposableDialog
			open={open}
			onCancel={wrappedOnCancel}
			footer={
				<>
					<Button
						dataCy="deleteGroupModal"
						variant="contained"
						color="error"
						disabled={!checked}
						onClick={() => {
							dispatch(deleteSensorGroup(sensorGroupId));
						}}>
						{t('Delete')}
					</Button>
					<Button
						dataCy="cancelModal"
						variant="contained"
						color="secondary"
						onClick={() => {
							wrappedOnCancel();
						}}>
						{t('Cancel')}
					</Button>
				</>
			}
			title={`${t('Delete sensor group')} ${
				formRef.current?.values.name || ''
			}?`}>
			<div>
				<div style={{ height: 119 }}>
					{t('Do you really want to delete this item?')}
					<br />
					{t('This action cannot be undone.')}
				</div>
				<FormControl
					style={{
						display: 'grid',
						gridTemplateColumns: '50px 1fr',
						width: 552,
						maxWidth: '100%',
						alignItems: 'end',
					}}>
					<Checkbox
						data-cy="checkbox"
						checked={checked}
						onChange={toggleChecked}
						color="primary"
					/>
					<div>
						{t(
							'I understand that deleting this sensor group may impact existing tools, charts, and alerts.',
						)}
					</div>
				</FormControl>
			</div>
		</StylovyzeComposableDialog>
	);
}
